import React, { useState, useEffect } from 'react';
import { FaPlus, FaSearch, FaEdit, FaTrash, FaSave, FaTimes } from 'react-icons/fa';
import Toggle from '../../../Common/Toggle/Toggle';
import '../Nucleos/Nucleos.css';
import './PareamentoLeis.css';

import API_BASE_URL from '../../../../config/api';

const PareamentoLeis = () => {
  const [pareamentos, setPareamentos] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [activeTab, setActiveTab] = useState('principal');
  
  // Estados para dados das tabelas de referência
  const [classificacoesEnquadramento, setClassificacoesEnquadramento] = useState([]);
  const [orgaosReferencia, setOrgaosReferencia] = useState([]);
  const [tiposEnquadramento, setTiposEnquadramento] = useState([]);
  const [atividadesCNAE, setAtividadesCNAE] = useState([]);
  const [areasEmpreendimento, setAreasEmpreendimento] = useState([]);
  const [investimentosUFM, setInvestimentosUFM] = useState([]);
  const [quadrosFuncionais, setQuadrosFuncionais] = useState([]);
  const [grausPoluidores, setGrausPoluidores] = useState([]);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  
  const [formData, setFormData] = useState({
    // Aba Principal - CÓDIGO REMOVIDO
    id_classificacao_enquadramento: '',
    id_orgao_referencia: '',
    id_atividade_cnae: '',
    // Aba Análise Geral
    id_area_empreendimento: '',
    unidade_medida: '',
    id_investimento_ufm: '',
    id_grau_poluidor: '',
    id_quadro_funcional: '',
    id_tipo_enquadramento: '',
    potencial_forte_poluidor: '',
    faixa_licenciamento_micro: '',
    faixa_licenciamento_pequeno: '',
    faixa_licenciamento_medio: '',
    faixa_licenciamento_grande: '',
    faixa_licenciamento_especial: '',
    ativo: true
  });

  // Carregar todas as tabelas de referência
  useEffect(() => {
    carregarPareamentos();
    carregarClassificacoesEnquadramento();
    carregarOrgaosReferencia();
    carregarTiposEnquadramento();
    carregarAtividadesCNAE();
    carregarAreasEmpreendimento();
    carregarInvestimentosUFM();
    carregarQuadrosFuncionais();
    carregarGrausPoluidores();
  }, []);

  const carregarPareamentos = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${API_BASE_URL}/pareamento-leis`);
      if (response.ok) {
        const data = await response.json();
        setPareamentos(data);
      }
    } catch (error) {
      console.error('Erro ao carregar pareamentos:', error);
      alert('Erro ao carregar pareamentos de leis.');
    } finally {
      setLoading(false);
    }
  };

  const carregarClassificacoesEnquadramento = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/classificacao-enquadramento`);
      if (response.ok) {
        const data = await response.json();
        setClassificacoesEnquadramento(data);
      }
    } catch (error) {
      console.error('Erro ao carregar classificações de enquadramento:', error);
    }
  };

  const carregarOrgaosReferencia = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/orgaos-referencia`);
      if (response.ok) {
        const data = await response.json();
        setOrgaosReferencia(data);
      }
    } catch (error) {
      console.error('Erro ao carregar órgãos de referência:', error);
    }
  };

  const carregarTiposEnquadramento = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/tipo-enquadramento`);
      if (response.ok) {
        const data = await response.json();
        setTiposEnquadramento(data);
      }
    } catch (error) {
      console.error('Erro ao carregar tipos de enquadramento:', error);
    }
  };

  const carregarAtividadesCNAE = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/atividades-cnae`);
      if (response.ok) {
        const data = await response.json();
        setAtividadesCNAE(data);
      }
    } catch (error) {
      console.error('Erro ao carregar atividades CNAE:', error);
    }
  };

  const carregarAreasEmpreendimento = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/area-empreendimento`);
      if (response.ok) {
        const data = await response.json();
        setAreasEmpreendimento(data);
      }
    } catch (error) {
      console.error('Erro ao carregar áreas de empreendimento:', error);
    }
  };

  const carregarInvestimentosUFM = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/investimento-ufm`);
      if (response.ok) {
        const data = await response.json();
        setInvestimentosUFM(data);
      }
    } catch (error) {
      console.error('Erro ao carregar investimentos UFM:', error);
    }
  };

  const carregarQuadrosFuncionais = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/quadro-funcional`);
      if (response.ok) {
        const data = await response.json();
        setQuadrosFuncionais(data);
      }
    } catch (error) {
      console.error('Erro ao carregar quadros funcionais:', error);
    }
  };

  const carregarGrausPoluidores = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/grau-poluidor`);
      if (response.ok) {
        const data = await response.json();
        setGrausPoluidores(data);
      }
    } catch (error) {
      console.error('Erro ao carregar graus poluidores:', error);
    }
  };

  const [filteredPareamentos, setFilteredPareamentos] = useState([]);

  useEffect(() => {
    const filtered = pareamentos.filter(pareamento =>
      (pareamento.atividade_cnae || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
      (pareamento.classificacao_enquadramento || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
      (pareamento.orgao_referencia || '').toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFilteredPareamentos(filtered);
  }, [searchTerm, pareamentos]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    
    const payload = {
      id_classificacao_enquadramento: formData.id_classificacao_enquadramento || null,
      id_orgao_referencia: formData.id_orgao_referencia || null,
      id_atividade_cnae: formData.id_atividade_cnae || null,
      id_area_empreendimento: formData.id_area_empreendimento || null,
      unidade_medida: formData.unidade_medida || null,
      id_investimento_ufm: formData.id_investimento_ufm || null,
      id_grau_poluidor: formData.id_grau_poluidor || null,
      id_quadro_funcional: formData.id_quadro_funcional || null,
      id_tipo_enquadramento: formData.id_tipo_enquadramento || null,
      potencial_forte_poluidor: formData.potencial_forte_poluidor || null,
      faixa_licenciamento_micro: formData.faixa_licenciamento_micro || null,
      faixa_licenciamento_pequeno: formData.faixa_licenciamento_pequeno || null,
      faixa_licenciamento_medio: formData.faixa_licenciamento_medio || null,
      faixa_licenciamento_grande: formData.faixa_licenciamento_grande || null,
      faixa_licenciamento_especial: formData.faixa_licenciamento_especial || null,
      ativo: formData.ativo
    };

    try {
      if (editingId) {
        const response = await fetch(`${API_BASE_URL}/pareamento-leis/${editingId}`, {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        });

        if (!response.ok) {
          throw new Error('Erro ao atualizar pareamento');
        }

        const updated = await response.json();
        setPareamentos((prev) =>
          prev.map((p) => (p.id === editingId ? updated : p))
        );
        alert('Pareamento atualizado com sucesso!');
      } else {
        const response = await fetch(`${API_BASE_URL}/pareamento-leis`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        });

        if (!response.ok) {
          throw new Error('Erro ao criar pareamento');
        }

        const created = await response.json();
        setPareamentos((prev) => [created, ...prev]);
        alert('Pareamento criado com sucesso!');
      }
      
      resetForm();
    } catch (error) {
      console.error('Erro ao salvar pareamento:', error);
      alert('Erro ao salvar pareamento. Verifique os dados e tente novamente.');
    } finally {
      setSaving(false);
    }
  };

  const handleEdit = (pareamento) => {
    setEditingId(pareamento.id);
    setFormData({
      id_classificacao_enquadramento: pareamento.id_classificacao_enquadramento || '',
      id_orgao_referencia: pareamento.id_orgao_referencia || '',
      id_atividade_cnae: pareamento.id_atividade_cnae || '',
      id_area_empreendimento: pareamento.id_area_empreendimento || '',
      unidade_medida: pareamento.unidade_medida || '',
      id_investimento_ufm: pareamento.id_investimento_ufm || '',
      id_grau_poluidor: pareamento.id_grau_poluidor || '',
      id_quadro_funcional: pareamento.id_quadro_funcional || '',
      id_tipo_enquadramento: pareamento.id_tipo_enquadramento || '',
      potencial_forte_poluidor: pareamento.potencial_forte_poluidor || '',
      faixa_licenciamento_micro: pareamento.faixa_licenciamento_micro || '',
      faixa_licenciamento_pequeno: pareamento.faixa_licenciamento_pequeno || '',
      faixa_licenciamento_medio: pareamento.faixa_licenciamento_medio || '',
      faixa_licenciamento_grande: pareamento.faixa_licenciamento_grande || '',
      faixa_licenciamento_especial: pareamento.faixa_licenciamento_especial || '',
      ativo: pareamento.ativo
    });
    setShowForm(true);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Tem certeza que deseja excluir este pareamento?')) {
      return;
    }

    try {
      const response = await fetch(`${API_BASE_URL}/pareamento-leis/${id}`, {
        method: 'DELETE'
      });

      if (!response.ok && response.status !== 204) {
        throw new Error('Erro ao excluir pareamento');
      }

      setPareamentos((prev) => prev.filter((p) => p.id !== id));
      alert('Pareamento excluído com sucesso!');
    } catch (error) {
      console.error('Erro ao excluir pareamento:', error);
      alert('Erro ao excluir pareamento. Tente novamente.');
    }
  };

  const resetForm = () => {
    setFormData({
      id_classificacao_enquadramento: '',
      id_orgao_referencia: '',
      id_atividade_cnae: '',
      id_area_empreendimento: '',
      unidade_medida: '',
      id_investimento_ufm: '',
      id_grau_poluidor: '',
      id_quadro_funcional: '',
      id_tipo_enquadramento: '',
      potencial_forte_poluidor: '',
      faixa_licenciamento_micro: '',
      faixa_licenciamento_pequeno: '',
      faixa_licenciamento_medio: '',
      faixa_licenciamento_grande: '',
      faixa_licenciamento_especial: '',
      ativo: true
    });
    setEditingId(null);
    setShowForm(false);
    setActiveTab('principal');
  };

  return (
    <div className="nucleos-container">
      <div className="tabela-header">
        <div className="header-content">
          <h1>Pareamento de Leis</h1>
          <p>Gerenciamento de pareamento entre leis e regulamentações</p>
        </div>
        {!showForm && (
          <button 
            className="btn-primary"
            onClick={() => setShowForm(true)}
          >
            <FaPlus /> Cadastrar Pareamento
          </button>
        )}
      </div>

      {showForm ? (
        <div className="inline-form">
          <div className="form-header">
            <h2>{editingId ? 'Editar Pareamento' : 'Cadastrar Pareamento'}</h2>
          </div>
          
          <div className="tabs-container">
            <div className="tabs-header">
              <button 
                type="button"
                className={`tab-button ${activeTab === 'principal' ? 'active' : ''}`}
                onClick={() => setActiveTab('principal')}
              >
                Aba Principal
              </button>
              <button 
                type="button"
                className={`tab-button ${activeTab === 'analise' ? 'active' : ''}`}
                onClick={() => setActiveTab('analise')}
              >
                Aba Análise Geral
              </button>
            </div>
            
            <form onSubmit={handleSubmit} className="form-content">
              {activeTab === 'principal' && (
                <div className="tab-content">
                  <div className="form-row">
                    <div className="form-group">
                      <label htmlFor="id_classificacao_enquadramento">Classificação Enquadramento *</label>
                      <select
                        id="id_classificacao_enquadramento"
                        value={formData.id_classificacao_enquadramento}
                        onChange={(e) => setFormData({...formData, id_classificacao_enquadramento: e.target.value})}
                        required
                      >
                        <option value="">Selecione...</option>
                        {classificacoesEnquadramento
                          .filter(c => c.ativo)
                          .map((classificacao) => (
                            <option key={classificacao.id_classificacao_enquadramento} value={classificacao.id_classificacao_enquadramento}>
                              {classificacao.nome_classificacao_enquadramento}
                            </option>
                          ))}
                      </select>
                    </div>
                    <div className="form-group">
                      <label htmlFor="id_orgao_referencia">Órgão de Referência *</label>
                      <select
                        id="id_orgao_referencia"
                        value={formData.id_orgao_referencia}
                        onChange={(e) => setFormData({...formData, id_orgao_referencia: e.target.value})}
                        required
                      >
                        <option value="">Selecione...</option>
                        {orgaosReferencia
                          .filter(o => o.ativo)
                          .map((orgao) => (
                            <option key={orgao.id_orgao_referencia} value={orgao.id_orgao_referencia}>
                              {orgao.nome_orgao_referencia}
                            </option>
                          ))}
                      </select>
                    </div>
                  </div>

                  <div className="form-group">
                    <label htmlFor="id_atividade_cnae">Atividade CNAE *</label>
                    <select
                      id="id_atividade_cnae"
                      value={formData.id_atividade_cnae}
                      onChange={(e) => setFormData({...formData, id_atividade_cnae: e.target.value})}
                      required
                    >
                      <option value="">Selecione uma atividade CNAE...</option>
                      {atividadesCNAE
                        .filter(a => a.ativo)
                        .map((atividade) => (
                          <option key={atividade.id} value={atividade.id}>
                            {atividade.codigo} - {atividade.descricao}
                          </option>
                        ))}
                    </select>
                    <small style={{color: '#666', fontSize: '12px', marginTop: '4px', display: 'block'}}>
                      Ao selecionar uma atividade CNAE, os campos Seção, Divisão, Grupo, Classe, Subclasse e Dígito são preenchidos automaticamente.
                    </small>
                  </div>
                </div>
              )}

              {activeTab === 'analise' && (
                <div className="tab-content">
                  <div className="form-row">
                    <div className="form-group">
                      <label htmlFor="id_area_empreendimento">Área Empreendimento</label>
                      <select
                        id="id_area_empreendimento"
                        value={formData.id_area_empreendimento}
                        onChange={(e) => setFormData({...formData, id_area_empreendimento: e.target.value})}
                      >
                        <option value="">Selecione...</option>
                        {areasEmpreendimento
                          .filter(a => a.ativo)
                          .map((area) => (
                            <option key={area.id} value={area.id}>
                              {area.nomeclatura} ({area.sigla})
                            </option>
                          ))}
                      </select>
                    </div>
                    <div className="form-group">
                      <label htmlFor="unidade_medida">Unidade de Medida</label>
                      <input
                        type="text"
                        id="unidade_medida"
                        value={formData.unidade_medida}
                        onChange={(e) => setFormData({...formData, unidade_medida: e.target.value})}
                        placeholder="Ex: m², hectares"
                      />
                    </div>
                  </div>

                  <div className="form-row">
                    <div className="form-group">
                      <label htmlFor="id_investimento_ufm">Investimento UFM</label>
                      <select
                        id="id_investimento_ufm"
                        value={formData.id_investimento_ufm}
                        onChange={(e) => setFormData({...formData, id_investimento_ufm: e.target.value})}
                      >
                        <option value="">Selecione...</option>
                        {investimentosUFM
                          .filter(i => i.ativo)
                          .map((investimento) => (
                            <option key={investimento.id} value={investimento.id}>
                              {investimento.nomeclatura} ({investimento.sigla})
                            </option>
                          ))}
                      </select>
                    </div>
                    <div className="form-group">
                      <label htmlFor="id_grau_poluidor">Grau Poluidor / Porte</label>
                      <select
                        id="id_grau_poluidor"
                        value={formData.id_grau_poluidor}
                        onChange={(e) => setFormData({...formData, id_grau_poluidor: e.target.value})}
                      >
                        <option value="">Selecione...</option>
                        {grausPoluidores
                          .filter(g => g.ativo)
                          .map((grau) => (
                            <option key={grau.id} value={grau.id}>
                              {grau.grau_poluidor} - Porte: {grau.porte} / Grau: {grau.grau}
                            </option>
                          ))}
                      </select>
                    </div>
                  </div>

                  <div className="form-row">
                    <div className="form-group">
                      <label htmlFor="id_quadro_funcional">Quadro Funcional</label>
                      <select
                        id="id_quadro_funcional"
                        value={formData.id_quadro_funcional}
                        onChange={(e) => setFormData({...formData, id_quadro_funcional: e.target.value})}
                      >
                        <option value="">Selecione...</option>
                        {quadrosFuncionais
                          .filter(q => q.ativo)
                          .map((quadro) => (
                            <option key={quadro.id} value={quadro.id}>
                              {quadro.descricao} ({quadro.sigla}) - Faixa: {quadro.faixa}
                            </option>
                          ))}
                      </select>
                    </div>
                    <div className="form-group">
                      <label htmlFor="id_tipo_enquadramento">Tipo Enquadramento</label>
                      <select
                        id="id_tipo_enquadramento"
                        value={formData.id_tipo_enquadramento}
                        onChange={(e) => setFormData({...formData, id_tipo_enquadramento: e.target.value})}
                      >
                        <option value="">Selecione...</option>
                        {tiposEnquadramento
                          .filter(t => t.ativo)
                          .map((tipo) => (
                            <option key={tipo.id_tipo_enquadramento} value={tipo.id_tipo_enquadramento}>
                              {tipo.nome_tipo_enquadramento}
                            </option>
                          ))}
                      </select>
                    </div>
                  </div>

                  <div className="form-row">
                    <div className="form-group">
                      <label htmlFor="potencial_forte_poluidor">Potencial Forte Poluidor</label>
                      <select
                        id="potencial_forte_poluidor"
                        value={formData.potencial_forte_poluidor}
                        onChange={(e) => setFormData({...formData, potencial_forte_poluidor: e.target.value})}
                      >
                        <option value="">Selecione...</option>
                        <option value="Sim">Sim</option>
                        <option value="Não">Não</option>
                        <option value="N.A.">N.A.</option>
                      </select>
                    </div>
                  </div>

                  <div className="form-group">
                    <label>Faixas de Licenciamento</label>
                    <small style={{color: '#666', fontSize: '12px', marginBottom: '8px', display: 'block'}}>
                      Informe os valores ou critérios para cada faixa de licenciamento
                    </small>
                    <div className="form-row">
                      <div className="form-group">
                        <label htmlFor="faixa_licenciamento_micro">Faixa 1 - MICRO</label>
                        <input
                          type="text"
                          id="faixa_licenciamento_micro"
                          value={formData.faixa_licenciamento_micro}
                          onChange={(e) => setFormData({...formData, faixa_licenciamento_micro: e.target.value})}
                          placeholder="Ex: Aplicável, Não se aplica, valor"
                        />
                      </div>
                      <div className="form-group">
                        <label htmlFor="faixa_licenciamento_pequeno">Faixa 2 - PEQUENO</label>
                        <input
                          type="text"
                          id="faixa_licenciamento_pequeno"
                          value={formData.faixa_licenciamento_pequeno}
                          onChange={(e) => setFormData({...formData, faixa_licenciamento_pequeno: e.target.value})}
                          placeholder="Ex: Aplicável, Não se aplica, valor"
                        />
                      </div>
                      <div className="form-group">
                        <label htmlFor="faixa_licenciamento_medio">Faixa 3 - MÉDIO</label>
                        <input
                          type="text"
                          id="faixa_licenciamento_medio"
                          value={formData.faixa_licenciamento_medio}
                          onChange={(e) => setFormData({...formData, faixa_licenciamento_medio: e.target.value})}
                          placeholder="Ex: Aplicável, Não se aplica, valor"
                        />
                      </div>
                      <div className="form-group">
                        <label htmlFor="faixa_licenciamento_grande">Faixa 4 - GRANDE</label>
                        <input
                          type="text"
                          id="faixa_licenciamento_grande"
                          value={formData.faixa_licenciamento_grande}
                          onChange={(e) => setFormData({...formData, faixa_licenciamento_grande: e.target.value})}
                          placeholder="Ex: Aplicável, Não se aplica, valor"
                        />
                      </div>
                      <div className="form-group">
                        <label htmlFor="faixa_licenciamento_especial">Faixa 5 - ESPECIAL (Dispensas)</label>
                        <input
                          type="text"
                          id="faixa_licenciamento_especial"
                          value={formData.faixa_licenciamento_especial}
                          onChange={(e) => setFormData({...formData, faixa_licenciamento_especial: e.target.value})}
                          placeholder="Ex: Dispensa, Não se aplica"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              )}

              <div className="form-group">
                <Toggle
                  id="ativo"
                  label="Status:"
                  checked={formData.ativo}
                  onChange={(e) => setFormData((prev) => ({...prev, ativo: e.target.checked}))}
                />
              </div>

              <div className="form-actions">
                <button type="button" className="btn-secondary" onClick={resetForm} disabled={saving}>
                  <FaTimes /> Cancelar
                </button>
                <button type="submit" className="btn-primary" disabled={saving}>
                  <FaSave /> {saving ? 'Salvando...' : (editingId ? 'Atualizar' : 'Cadastrar')}
                </button>
              </div>
            </form>
          </div>
        </div>
      ) : (
        <div className="table-container">
          <div className="table-controls">
            <div className="search-container">
              <FaSearch />
              <input
                type="text"
                placeholder="Pesquisar pareamentos..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
            <div className="table-info">
              <span>
                {loading
                  ? 'Carregando pareamentos...'
                  : `${filteredPareamentos.length} registro(s) encontrado(s)`}
              </span>
            </div>
          </div>

          <div className="table-wrapper">
            <table className="data-table">
              <thead>
                <tr>
                  <th className="col-id">ID</th>
                  <th className="col-nome">Atividade CNAE</th>
                  <th className="col-nome">Classificação</th>
                  <th className="col-nome">Órgão</th>
                  <th className="col-status">Status</th>
                  <th className="col-acoes">Ações</th>
                </tr>
              </thead>
              <tbody>
                {filteredPareamentos.map(pareamento => (
                  <tr key={pareamento.id}>
                    <td>{pareamento.id}</td>
                    <td>{pareamento.atividade_cnae || '-'}</td>
                    <td>{pareamento.classificacao_enquadramento || '-'}</td>
                    <td>{pareamento.orgao_referencia || '-'}</td>
                    <td>
                      <span className={`status-badge ${pareamento.ativo ? 'ativo' : 'inativo'}`}>
                        {pareamento.ativo ? 'Ativo' : 'Inativo'}
                      </span>
                    </td>
                    <td className="col-acoes">
                      <div className="action-buttons">
                        <button 
                          className="btn-edit"
                          onClick={() => handleEdit(pareamento)}
                          title="Editar"
                        >
                          <FaEdit />
                        </button>
                        <button 
                          className="btn-delete"
                          onClick={() => handleDelete(pareamento.id)}
                          title="Excluir"
                        >
                          <FaTrash />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            
            {filteredPareamentos.length === 0 && (
              <div className="empty-state">
                <div className="empty-state-icon">
                  <FaSearch />
                </div>
                <h3>Nenhum pareamento encontrado</h3>
                <p>Tente ajustar os filtros de pesquisa ou cadastre um novo pareamento.</p>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default PareamentoLeis;
